import React from "react";
import ContactsPage from "./views/ContactsPage";
import { ContactsContextProvider } from "./ContactsView";
import contactsContent from "../../constants/contentFile.json";
const Contacts = () => {
  return (
    <ContactsContextProvider>
      <ContactsPage textContants={contactsContent.contacts} />
    </ContactsContextProvider>
  );
};
export default Contacts;
